(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["membership-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:section:load', function(e){
  if (e.detail.sectionId !== '{{ section.id }}') return;
  // Ensure gradient and overlay styles re-render correctly in Theme Editor
});

  } catch(e) { console.error(e); }
})();
})();
